import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import '@/assets/styles/global.scss'
import messages from '@/locale'
import { useLangStore } from '@/stores/langStore'
import { setupAxios } from '@/services/customAxios'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
setupAxios(pinia)

const langStore = useLangStore()
const lang = langStore.lang

const i18n = createI18n({
  legacy: false,
  locale: lang,
  fallbackLocale: 'ru',
  messages,
})

app.use(router)
app.use(i18n)
app.mount('#app')
